import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventAccommodationsCheck } from '@shared/hooks/useEventAccommodationsCheck';
import { useRouterHelper } from '@shared/core';
import { withWindow } from '@shared/utils/withWindow';

export const usePurchaseConfirmationLink = (eventHandle: string) => {
  const [accommodationsOnRegistryConfirmationV2Experiment] = useIsFeatureEnabled('accommodationsOnRegistryConfirmationV2Experiment');
  const { isGuestRoute } = useRouterHelper();
  const { hasVisibleAccommodationsEventPage, hasVisibleTravelEventPage, hasTravelAccommodationListings } = useEventAccommodationsCheck({ eventHandle });

  return (initialSuccessUrl: string): string => {
    if (!accommodationsOnRegistryConfirmationV2Experiment || !isGuestRoute) {
      return initialSuccessUrl;
    }

    const utmQueryParams = '&utm_medium=web&utm_source=confirmation_registry_purchase&utm_campaign=next_steps';
    const baseUrl = withWindow(global => global.location.origin, '');
    const pcIdParam = `pcId=\${purchaseContextId}`;

    if (hasVisibleAccommodationsEventPage) {
      return `${baseUrl}/${eventHandle}/accommodations?${pcIdParam}${utmQueryParams}`;
    }

    if (hasVisibleTravelEventPage && hasTravelAccommodationListings) {
      return `${baseUrl}/${eventHandle}/travel?${pcIdParam}${utmQueryParams}`;
    }

    return `${baseUrl}/${eventHandle}/registry/accommodations?${pcIdParam}${utmQueryParams}`;
  };
};
